import { styled } from '@mui/material/styles';

import { MOBILE_CONTAINER_WIDTH } from '@mopla/constants';

export const Root = styled('div')(({ theme }) => ({
	height: '100%',
	width: '100%',
	maxWidth: MOBILE_CONTAINER_WIDTH,
	margin: 'auto',
	padding: '24px',
	paddingBottom: 24,
	boxSizing: 'border-box',
	display: 'grid',
	gridGap: 24,
	gridTemplateRows: 'max-content max-content 1fr max-content',
	'span:first-of-type': {
		marginTop: 40,
		marginBottom: 8,
	},
	backgroundColor: theme.palette.primary.main,
	overflow: 'auto',
	[theme.breakpoints.up('tabletP')]: {
		borderRadius: '8px 8px 0 0',
	},
}));
